const GroupAssetModel = {
    id: "",
    name: "",
    counter: 0,
    actives: []
}
export default GroupAssetModel